// extracted by mini-css-extract-plugin
module.exports = {"button-basic":"A_button-basic__n1mra","large":"A_large__dSCJM","a-basic":"A_a-basic__tBlq_"};